import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Step2Styles } from './Style'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { Words } from 'pages'
import { visibleTypes } from 'keys'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { IconButton } from '@mui/material'
import { Img } from 'styles/GlobalStyle'
import { Pause, PlayArrow } from '@mui/icons-material'
import { AnimatePresence } from 'framer-motion'
import { Go1Gif } from 'assets'
import { getWordDefsFetch } from 'store/middlewares/words.crud'
import { AbilityContext } from 'components/Permissions/Can'
import { performAssessmentHooks } from '.'
import { useParams } from 'react-router-dom'
import * as motion from "motion/react-client"
import ReactPlayer from 'react-player'
import categories from 'keys/categories'

const Step2 = () => {
    const { isHighGrade, assessmentDef, showNextButton, setCurrentStep, isMaleGender } = useContext(PerformAssessmentContext)
    const [cartoonSpeaking, setCartoonSpeaking] = useState(true)
    const queryClient = useQueryClient()
    const ability = useContext(AbilityContext)
    const params = useParams()
    const assessmentID = params.assessmentID

    const stepData = performAssessmentHooks.useStep2()
    const item = stepData?.[assessmentDef?.category_name] || stepData[categories.BIBLICAL_TEXT]

    const goNextStep = useCallback(() => {
        setCartoonSpeaking(false)
        // כרגע השתמשנו בדגל הזה במבדקי שאלון שבו מדלגים על שלב 3
        if (item?.skipNextStep)
            setCurrentStep(4)
        else
            //של הצעד הבא, כדי למנוע אפשרות של לחיצה כפולה שמעבירה שני צעדים index - חשוב לשים את המספר 
            setCurrentStep(3)
    }, [])

    const wordDefsData = useQuery({
        queryKey: [qc.exampleWordDefs, assessmentID, item?.assessmentId || 0],
        queryFn: async ({ signal }) => {
            if (item) {
                try {
                    const { data } = await getWordDefsFetch({ signal, id: item.assessmentId });
                    return data.word_defs;
                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        goNextStep()
                    }
                }
            }
            return [];
        },
        enabled: !!item?.assessmentId
    })

    const handleCartoonSpeaking = useCallback(() => {
        setCartoonSpeaking(cartoonSpeaking => !cartoonSpeaking)
    }, [])

    useEffect(() => {
        // בטקסט סיפורי מדלגים על ההדגמה
        if (assessmentDef?.visible_type && !item?.assessmentId && assessmentDef.visible_type == visibleTypes.PARAGRAPH) {
            goNextStep()
        }
    }, [assessmentDef])

    return (
        <Step2Styles>
            <div className='wrap-content-with-cartoon'>
                {isHighGrade ||
                    <div className='wrap-cartoon-img'>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ y: 1, x: 1, opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.7 }}
                            className='cartoon-img'
                            key="cartoon-img"
                        >
                            <Img src={cartoonSpeaking ? Go1Gif : Go1Gif} />
                            <div className='play-pause-cartoon'>
                                <IconButton onClick={handleCartoonSpeaking}>
                                    {cartoonSpeaking ? <Pause color="thirdly" /> : <PlayArrow color="thirdly" />}
                                </IconButton>
                            </div>
                        </motion.div>
                    </div>
                }
                {(wordDefsData?.data || item?.data) &&
                    <Words
                        questions={
                            assessmentDef?.category_name === categories.NARRATIVE_TEXT_NO_NIKUD ?
                                item?.data?.NO_NIKUD.questions :
                                item?.data?.NIKUD.questions
                        }
                        title={assessmentDef?.category_name === categories.NARRATIVE_TEXT_NO_NIKUD ?
                            item?.data?.NO_NIKUD.title :
                            item?.data?.NIKUD.title}
                        cartoonSpeaking={cartoonSpeaking}
                        handleCartoonSpeaking={() => setCartoonSpeaking(!cartoonSpeaking)}
                        showCartoon={!isHighGrade}
                        print={true}
                        type={assessmentDef?.visible_type}
                        name={assessmentDef?.name}
                        words={wordDefsData?.data || {}}
                        student={true}
                        handleNext={goNextStep}
                        boldWordAfterSeconds={item?.boldWordAfterSeconds}
                        changeBoldWordAfterSeconds={item?.changeBoldWordAfterSeconds}
                        hideNextButton={!showNextButton}
                        isDemo
                        showBlurred={(index) => index >= 9}
                    />}
            </div>
            {item?.record &&
                <ReactPlayer
                    playing={cartoonSpeaking}
                    url={item?.record}
                    controls={true}
                    width='0px' height='0px'
                    onEnded={goNextStep}
                />}
        </Step2Styles>
    )
}

export default Step2
